import { metaAccount } from '@/router/meta-config'
const permissionKey = 'PAGE'

export default [
  {
    path: '/tourist-agencies',
    name: 'page-tourist-agencies',
    component: () => import('@/pages/touristAgencies'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/tourist-agencies/new',
    name: 'page-tourist-agency-new',
    component: () => import('@/pages/touristAgency'),
    meta: {
      ...metaAccount,
      permissionKey
    }
  },
  {
    path: '/tourist-agencies/:id',
    name: 'page-tourist-agency',
    component: () => import('@/pages/touristAgency'),
    props: (route) => ({ id: route.params.id }),
    meta: {
      ...metaAccount,
      permissionKey
    }
  }
]
